"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var formik_1 = require("formik");
var react_bootstrap_1 = require("react-bootstrap");
var FieldWrapper_1 = __importDefault(require("../FieldWrapper"));
var ButtonsField = function (_a) {
    var _b;
    var question = _a.question, questionNumber = _a.questionNumber, fieldName = _a.fieldName, _c = _a.disabled, disabled = _c === void 0 ? false : _c;
    return (react_1.default.createElement(FieldWrapper_1.default, { questionNumber: questionNumber, instructions: question.instructions, fieldName: fieldName }, !((_b = question.options) === null || _b === void 0 ? void 0 : _b.length) ?
        react_1.default.createElement("h1", null, "No options for button field")
        :
            react_1.default.createElement(react_bootstrap_1.Row, { className: "justify-content-center", id: question.uniqueID + "-input" }, question.options.map(function (option, index) { return (react_1.default.createElement(formik_1.Field, { name: fieldName, key: index }, function (_a) {
                var field = _a.field, form = _a.form;
                return (react_1.default.createElement(react_bootstrap_1.Col, { className: "px-3", xs: "auto" },
                    react_1.default.createElement(react_bootstrap_1.Button, { variant: field.value === option.value ? "primary" : "outline-primary", onClick: function () { return form.setFieldValue(fieldName, option.value); }, key: option.value, disabled: disabled }, option.label)));
            })); }))));
};
exports.default = ButtonsField;
